webpackJsonp([21],{

/***/ 1053:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_failed_page_vue__ = __webpack_require__(1106);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b83d048_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_failed_page_vue__ = __webpack_require__(1181);
function injectStyle (ssrContext) {
  __webpack_require__(1179)
}
var normalizeComponent = __webpack_require__(24)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6b83d048"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_failed_page_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b83d048_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_failed_page_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1106:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      paymentID: 123456
    };
  },
  beforeMount: function beforeMount() {
    // this.showLoading();
    var paymentID = this.$route.params.paymentID;

    this.paymentID = paymentID;
  },
  mounted: function mounted() {},

  methods: {
    goToTypePage: function goToTypePage() {
      if (this.$cookies.get('retry_type') == "movie") {
        this.$router.push({
          name: "movie",
          params: {
            movieID: this.$cookies.get('retry_id'),
            cinemaID: "0"
          }
        });
      } else {
        this.$router.push({
          name: "eventDetails",
          params: {
            eventID: this.$cookies.get('retry_id')
          }
        });
      }
    }
  }
});

/***/ }),

/***/ 1179:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1180);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1036)("484d230f", content, true, {});

/***/ }),

/***/ 1180:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1035)(true);
// imports


// module
exports.push([module.i, ".small-md[data-v-6b83d048]{font-size:14px}", "", {"version":3,"sources":["/var/www/html/cineco/website/vue-pwa-initial-setup/src/components/pages/failed-page.vue"],"names":[],"mappings":"AACA,2BACE,cAAgB,CACjB","file":"failed-page.vue","sourcesContent":["\n.small-md[data-v-6b83d048] {\n  font-size: 14px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1181:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('div',[_c('div',{staticClass:"d-flex justify-content-center align-items-center error-container"},[_c('div',{staticClass:"text-center"},[_c('div',[_c('svg',{attrs:{"width":"50px","height":"50px","version":"1.1","viewBox":"0 0 1200 1200","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"m250.27 1142.2c-51.336 57.754-147.59 57.754-198.93 0-57.754-57.754-57.754-147.59 0-205.35l333.69-340.11-333.69-333.69c-57.754-57.754-57.754-147.59 0-205.35 51.336-57.754 147.59-57.754 198.93 0l340.11 340.11 352.94-352.94c57.754-57.754 147.59-57.754 205.35 0 57.754 51.336 57.754 147.59 0 198.93l-352.94 352.94 352.94 352.94c57.754 57.754 57.754 147.59 0 205.35s-147.59 57.754-205.35 0l-352.94-352.94-340.11 340.11z","fill":"#0f4c9d"}})])]),_vm._v(" "),_c('div',{staticClass:"faipay-fs"},[_vm._v("Your Payment Failed")]),_vm._v(" "),_c('h5',[_vm._v("\n          Payment for "),_c('b',[_vm._v("order ID "+_vm._s(_vm.paymentID))]),_vm._v(" could not be proceed.\n          Try again\n        ")]),_vm._v(" "),_c('div',{staticClass:"text-center mt-4"},[_c('button',{staticClass:"btn btn-pink px-5",on:{"click":_vm.goToTypePage}},[_vm._v("RETRY")])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/21.e0bc7b2bf66018c09808.js